const relacao_escola_contraturno = [
  {
    path: "/relacao-escola-contraturno",
    // redirect: "/relacao-escola-contraturno",
    meta: {
      breadCrumb: "Relação de Escolas com Contraturno",
    },
    children: [
      {
        path: "/relacao-escola-contraturno",
        name: "relacao_escola_contraturno",
        component: () =>
          import(
            "@/views/RelatorioEscolaContraTurno/RelatorioEscolaContraTurno.vue"
          ),
      },
    ],
  },
];

export { relacao_escola_contraturno };
